export const ROUTES = {
  REFRA_CATALOG: {
    path: 'catalog'
  },
  REFRA_PLANNING: {
    path: 'planning'
  },
  FLEXIBLE_REPORT: {
    path: 'flexible-report'
  },
  STATIC_PARTS: {
    path: 'static-parts/*',
    OVERVIEW: {
      path: ':selectedKilnId'
    },
    DETAIL: {
      path: ':selectedKilnId/:staticPartId'
    },
    EDIT: {
      path: ':selectedKilnId/:staticPartId/edit/*',
      COMPONENT_EDIT: {
        path: ':componentId/:shutdownId'
      }
    }
  },
  NOT_AUTHORIZED: {
    path: '/403'
  },
  NOT_FOUND: {
    path: '/404'
  }
}
